import { Plus } from '@liveauctioneers/hammer-ui-core/icons';
import { OptionType } from '@liveauctioneers/hammer-ui-core/select';
import { Caption } from '@liveauctioneers/hammer-ui-core/text';

import SortPageSizePair from '@/components/Pagination/hammer-pagination/SortPageSizePair';
import { SubtleRouteLink } from '@/components/RouteLinks/RouteLinks';
import { savedSearchItemSortOrders } from '@/enums';
import { PaginationFilter } from '@/types/PaginationFilter';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { getSearchBaseUrl } from '@/utils/urls';

type Props = {
    filters: PaginationFilter;
    onFilterChange: (filters: PaginationFilter) => void;
};

export const SavedSearchNotificationFilter = ({ filters, onFilterChange }: Props) => {
    const newTermUrl = `${getSearchBaseUrl()}?newTerm=true`;
    const formatMessage = useAppFormatMessage();

    const OPTIONS: OptionType[] = [
        {
            label: String(formatMessage(['search_alerts', 'sort', 'newlyListed'])),
            value: savedSearchItemSortOrders.NEWLY_LISTED,
        },
        {
            label: String(formatMessage(['search_alerts', 'sort', 'startingSoonest'])),
            value: savedSearchItemSortOrders.STARTING_SOONEST,
        },
    ];

    return (
        <div className="flex flex-row items-center justify-between border-b border-border-secondary py-lg">
            <SortPageSizePair
                hideSort={filters.tab === 'searches'}
                isInsideLabel
                onChange={onFilterChange}
                pageSizeLabelClassName="xsMax:min-w-[50px]"
                paginationFilter={filters}
                sortOptions={OPTIONS}
            />
            <span className="[&:hover_*]:text-primary-400">
                <SubtleRouteLink
                    className="inline-flex items-center text-text-secondary"
                    id="search_alerts.placeholder"
                    to={newTermUrl}
                >
                    <Plus
                        className="mr-xs"
                        size="sm"
                        style="bold"
                    />
                    <Caption
                        color="secondary"
                        data-testid="addNewSearchTerm"
                    >
                        {formatMessage(['search_alerts', 'add_new_search'])}
                    </Caption>
                </SubtleRouteLink>
            </span>
        </div>
    );
};
